module.exports = __webpack_public_path__ + "static/img/ziti.003180f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crm/renzheng/ziti.png
// module id = Al4H
// module chunks = 2